"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var currency_1 = require("@reverbdotcom/commons/dist/currency");
var money_1 = require("@reverbdotcom/commons/dist/money");
var IUserType;
(function (IUserType) {
    IUserType["BUYER"] = "buyer";
    IUserType["SELLER"] = "seller";
})(IUserType = exports.IUserType || (exports.IUserType = {}));
var IRefundType;
(function (IRefundType) {
    IRefundType["FULL"] = "full";
    IRefundType["PARTIAL"] = "partial";
})(IRefundType = exports.IRefundType || (exports.IRefundType = {}));
var IRefundState;
(function (IRefundState) {
    IRefundState["APPROVED"] = "approved";
    IRefundState["CONDITIONALLY_APPROVED"] = "conditionally_approved";
    IRefundState["DENIED"] = "denied";
})(IRefundState = exports.IRefundState || (exports.IRefundState = {}));
exports.OTHER_REASON = 'other';
function getInitialRefundState(canConditionallyApprove) {
    if (canConditionallyApprove) {
        return IRefundState.CONDITIONALLY_APPROVED;
    }
    return IRefundState.APPROVED;
}
exports.getInitialRefundState = getInitialRefundState;
function mapRefundTypeToRefundState(refundType, canConditionallyApprove) {
    if (refundType === IRefundType.FULL && canConditionallyApprove) {
        return IRefundState.CONDITIONALLY_APPROVED;
    }
    return IRefundState.APPROVED;
}
exports.mapRefundTypeToRefundState = mapRefundTypeToRefundState;
function needsCurrencyExchange(refundableOrder, userType) {
    if (userType !== IUserType.BUYER) {
        return false;
    }
    return refundableOrder.settlementCurrency !== refundableOrder.displayCurrency;
}
exports.needsCurrencyExchange = needsCurrencyExchange;
function amountInSettlementCurrency(enteredAmount, refundableOrder) {
    var displayCurrency = refundableOrder.displayCurrency, settlementCurrency = refundableOrder.settlementCurrency, fromDisplayCurrencyToSettlementCurrencyExchangeRate = refundableOrder.fromDisplayCurrencyToSettlementCurrencyExchangeRate;
    var fromCurrencyConfig = currency_1.default.get(displayCurrency);
    var toCurrencyConfig = currency_1.default.get(settlementCurrency);
    var amountCentsInDisplayCurrency = money_1.parseAmount(enteredAmount, displayCurrency).amountCents;
    if (amountCentsInDisplayCurrency === 0) {
        return null;
    }
    var fractionalAmount = amountCentsInDisplayCurrency /
        (fromCurrencyConfig.subunitToUnit / toCurrencyConfig.subunitToUnit);
    var toAmountCents = fractionalAmount * fromDisplayCurrencyToSettlementCurrencyExchangeRate;
    return money_1.parseAmountCents(toAmountCents, settlementCurrency);
}
exports.amountInSettlementCurrency = amountInSettlementCurrency;
function getInitialAmount(refundRequest, userType) {
    if (userType !== IUserType.BUYER &&
        refundRequest.isPersisted &&
        refundRequest.requestedAmount) {
        return refundRequest.requestedAmount.amount;
    }
    return '';
}
exports.getInitialAmount = getInitialAmount;
// When a seller updates a refund request there is no refund type selector, only an amount input.
// This is used to display different refund explanation line items based on the entered amount.
function isFullRefund(order, amountInSettlementCurrency) {
    var amount = money_1.parseAmount(amountInSettlementCurrency, order.settlementCurrency);
    return amount.amountCents >= order.amountAvailableToRefund.amountCents;
}
exports.isFullRefund = isFullRefund;
//# sourceMappingURL=refund_request.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/refund_requests/refund_request.js
// module id = WWm2
// module chunks = 20 21